import { axiosInstance } from "../../../axios/axiosInstance";

const API_SERVICES_URL = "organization/services/";
const API_SERVICES_MODULE_LIST_URL =
  API_SERVICES_URL + "get-all-provider-services";
const API_CREATE_SERVICE_MODULE_URL = API_SERVICES_URL + "add-service";
const API_UPDATE_SERVICE_MODULE_URL = API_SERVICES_URL + "update-service";
const API_GET_SERVICE_MODULE_BY_ID_URL = API_SERVICES_URL + "get-service-by-id";
const API_DELETE_SERVICE_MODULE_URL = API_SERVICES_URL + "update-status";

export const getServices = (dataToBeSent) => {
  return axiosInstance.get(
    `${API_SERVICES_MODULE_LIST_URL}?page=${dataToBeSent?.page || ""}&limit=${
      dataToBeSent?.limit || ""
    }&search=${dataToBeSent?.search || ""}`
  );
};

export const getServicesSelectList = (dataToBeSent) => {
  return axiosInstance.get(
    `${API_SERVICES_MODULE_LIST_URL}?page=${dataToBeSent?.page || ""}&limit=${
      dataToBeSent?.limit || ""
    }&search=${dataToBeSent?.search || ""}`
  );
};

export const createService = (dataToBeSent) => {
  return axiosInstance.post(API_CREATE_SERVICE_MODULE_URL, dataToBeSent);
};

export const updateService = (dataToBeSent) => {
  return axiosInstance.patch(
    API_UPDATE_SERVICE_MODULE_URL + "/" + dataToBeSent?._id,
    dataToBeSent
  );
};

export const getServiceById = (dataToBeSent) => {
  return axiosInstance.get(
    API_GET_SERVICE_MODULE_BY_ID_URL + "/" + dataToBeSent?.selectedServiceId
  );
};

export const deleteServiceById = (dataToBeSent) => {
  return axiosInstance.patch(
    API_DELETE_SERVICE_MODULE_URL + "/" + dataToBeSent?.selectedServiceId,
    {
      is_active: false,
    }
  );
};
